import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sophistiscan-token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('sophistiscan-token');
      localStorage.removeItem('sophistiscan-user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (data) => api.post('/auth/register', data),
  getMe: () => api.get('/auth/me'),
  updateLanguage: (language) => api.put('/auth/language', { language }),
  changePassword: (currentPassword, newPassword) =>
    api.put('/auth/password', { currentPassword, newPassword }),
};

// Profiles
export const profilesAPI = {
  list: () => api.get('/profiles'),
  get: (id) => api.get(`/profiles/${id}`),
  create: (data) => api.post('/profiles', data),
  update: (id, data) => api.put(`/profiles/${id}`, data),
  delete: (id) => api.delete(`/profiles/${id}`),
};

// Scanner
export const scannerAPI = {
  getCommands: () => api.get('/scanner/commands'),
  buildCommand: (operand, data, permanent) =>
    api.post('/scanner/build-command', { operand, data, permanent }),
  buildCompound: (commands) =>
    api.post('/scanner/build-compound', { commands }),
};

// History
export const historyAPI = {
  list: (page = 1, limit = 20) => api.get(`/history?page=${page}&limit=${limit}`),
  logSerial: (data) => api.post('/history/serial', data),
  getSerialLog: (limit = 50) => api.get(`/history/serial?limit=${limit}`),
};

// Files
export const filesAPI = {
  list: () => api.get('/files'),
  upload: (formData) => api.post('/files', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  update: (id, data) => api.put(`/files/${id}`, data),
  delete: (id) => api.delete(`/files/${id}`),
  downloadUrl: (id) => `${API_BASE}/files/${id}/download`,
};

export default api;
